import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ chapter, eyebrow, title, description, dark = false }) => (
  <div className="max-w-2xl">
    {chapter && (
      <Reveal>
        <p
          className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] ${
            dark ? "text-gold" : "text-gold-dark"
          }`}
        >
          <span className="font-display text-base italic tracking-normal">{chapter}</span>
          <span className={`h-px w-10 ${dark ? "bg-gold/60" : "bg-gold"}`} aria-hidden="true" />
          {eyebrow}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display text-4xl leading-tight tracking-tight sm:text-5xl ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg ${dark ? "text-white/70" : "text-muted-foreground"}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
